"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.array.slice");
require("core-js/modules/es.regexp.exec");
require("core-js/modules/es.string.replace");
require("core-js/modules/es.string.split");
require("core-js/modules/es.string.trim");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EFormFields = _interopRequireDefault(require("../enums/EFormFields"));
var _default = function _default(value) {
  var _String$split = String(value.replace(/\s+/g, ' ').trim()).split(' '),
    surname = _String$split[0],
    name = _String$split[1],
    middleName = _String$split.slice(2);
  return {
    [_EFormFields.default.NAME]: name,
    [_EFormFields.default.SURNAME]: surname,
    [_EFormFields.default.MIDDLE_NAME]: middleName.join(' ')
  };
};
exports.default = _default;